<template>
    <div>
        <el-form class="form" ref="form" label-width="100px">
            <el-checkbox class="checkbox" v-model="checked"></el-checkbox>
            <el-form-item label="字体颜色" style="margin-bottom:12px;">
                <el-input v-model="data" type="textarea" :autosize="{minRows:1}" resize="none"></el-input>
            </el-form-item>
            <div class="examples">
                <el-button class="color-grey" type="info" size="mini" @click="fill('#989EA4')">灰色(默认)</el-button>
                <el-button class="color-black" type="info" size="mini" @click="fill('#000000')">黑色</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import attributeMixin from '../../mixins/graphic/attribute'
export default {
    name: 'Color',
    mixins: [attributeMixin],
    data() {
        return {
            type: 'Color',
            default: '',
        }
    },
    mounted() {
        this.fill('#989EA4')
    },
    methods: {
        fill(color) {
            this.data = color
        }
    }
}
</script>
<style lang="scss">
.form {
    display: flex;
    align-items: center;
}

.examples {
    margin-left: 0.533rem;

    .color-grey {
        background: #989EA4;
    }

    .color-black {
        background: #000000;
    }
}
</style>